// src/services/financialPostingService.js
// Updated: Monday, July 27, 2026 at 10:36 PM EDT

import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

const call = (name, data) => httpsCallable(functions, name)(data).then((result) => result.data);

export const postContributionBatch = (churchId, batchId) =>
  call('postContributionBatch', { churchId, batchId });

export const approveFinancialExpense = (churchId, expenseId) =>
  call('approveFinancialExpense', { churchId, expenseId });

export const revertFinancialExpense = (churchId, expenseId, reason) =>
  call('revertFinancialExpense', { churchId, expenseId, reason });

export const postFundTransferOrAdjustment = (churchId, payload) =>
  call('postFundTransferOrAdjustment', { churchId, ...payload });

export const voidPostedContribution = (churchId, transactionId, reason) =>
  call('voidPostedContribution', { churchId, transactionId, reason });
